import { Component, Output, EventEmitter, HostBinding, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { DirectLoggedOut } from '@uxdf/direct-shared-lib';
import { State } from '../../../../redux/reducers';

@Component({
  standalone: false,
  selector: 'app-direct-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderDirectComponent {
  @Output() menuToggle: EventEmitter<void>;
  @Output() searchPanelToggle: EventEmitter<void>;
  @HostBinding() class = 'portal-header no-print';
  @Input() hideMenu = true;
  logoutString = $localize`:header-direct.commonLogoutText:Log out`;

  constructor(private readonly store: Store<State>) {
    this.menuToggle = new EventEmitter();
    this.searchPanelToggle = new EventEmitter();
  }

  toggleSearchPanel() {
    this.searchPanelToggle.next();
  }

  toggleMenu() {
    this.menuToggle.next();
  }

  directLoggedOut() {
    this.store.dispatch(new DirectLoggedOut());
  }
}
